<template>
    <span>
        <v-btn
            @click="download"
            color="primary"
            :loading="$store.get('loader/loading', 'download')"
        >
            <v-icon left>mdi-download</v-icon>

            download
        </v-btn>

        <a
            @click="actualDownload"
            v-show="false"
            ref="download"
            :download="filename"
            :href="url"
        ></a>
    </span>
</template>

<script>
export default {
    props: {
        dateRange: {
            type: Array,
        }
    },

    data() {
        return {
            filename: null,
            url: null,
        }
    },

    methods: {
        download() {
            this.$api.get(`period/${this.$route.params.period_id}/paidUser/download`, {
                params: {
                    fromDate: this.dateRange[0],
                    toDate: this.dateRange[1]
                },
                responseType: 'blob',
                loader: 'download'
            })
                .then(response => {
                    this.url = URL.createObjectURL(response.data)
                    this.filename = `Pembayaran ${this.dateRange[0]} - ${this.dateRange[1]}.zip`

                    setTimeout(() => this.$refs.download.click(), 500)
                })
        },

        actualDownload() {
            setTimeout(() => URL.revokeObjectURL(this.url), 10000)
        }
    },
}
</script>
